module.exports = __webpack_public_path__ + "static/media/closed-eye.2475c4bc.svg";